<template>
  <div>
    <v-card class="pa-2">
      <v-row>
        <v-col cols="6">
          <span class="subtitle-1">{{ sheetObj.date | dateFormat }} {{ sheetObj.warehousename }} {{ sheetObj.type ? `(${this.$t(`message.warehouse.${sheetObj.type}`)})` : '' }}</span>
        </v-col>
        <v-col cols="6" class="text-right">
          <span class="subtitle-2">{{ $t(getStatusText) }}</span>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" sm="2" md="2" lg="1">
          <v-btn color="primary" @click="addNewItemHandler" :disabled="isSheetCompleted && !$route.params.has_edit" id="addNew" class="mt-3">{{ $t('message.common.new') }}</v-btn>
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="3">
          <v-textarea hide-details dense outlined rows="3" :label="$t('message.common.comments')" @change="updateComments" v-model="sheetObj.comments"></v-textarea>
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2">
          <v-autocomplete :items="selectedGroups" autocomplete="off" outlined dense multiple v-model="filterByProductGroup" clearable :item-text="(x) => `${x.number ? x.number + ' - ' : ''} ${x.name}`" item-value="id" hide-details :label="$t('message.user.group')"></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="2">
          <v-autocomplete :items="listOfLocations" autocomplete="off" outlined dense v-model="filterByLocation" clearable item-text="name" item-value="id" hide-details :label="$t('message.ccsheet.searchLocation')"></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="3" class="text-right">
          <v-text-field persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable append-icon="search" @keyup.enter="getCCSheetItems" @click:append="getCCSheetItems" outlined dense v-model="searchFilter" :label="$t('message.common.search')" class="search-hint-padding"></v-text-field>
        </v-col>
      </v-row>
      <v-card-text class="pa-0">
        <v-form ref="ccsheetItems">
          <v-progress-linear v-if="loadingProducts" indeterminate color="primary"></v-progress-linear>
          <v-data-table :headers="headers" :items="listOfCCSheetItems" :loading="loading" :options.sync="paginationObj" item-key="id" class="elevation-1"
            :server-items-length="total ? total : undefined"
            :footer-props="{ 'itemsPerPageOptions': [20, 50, 100, 300] }">
              <template v-slot:body="{ items  }">
                <tbody>
                  <tr v-for="(item, index) in addNewItems" :key="index" :style="{ background : item.productid ? item.color : undefined }" class="test">
                    <td class="pa-0 pl-1">
                      <v-autocomplete :items="item.products" autocomplete="off"
                        v-model="item.productid"
                        :tabindex="item.productid ? -1 : 0"
                        @keyup="$event.keyCode !== 13 ? loadProducts(`searchInput${index}`, index, $event) : ''"
                        :ref="`searchInput${index}`"
                        @click="toggleAllProducts(index, SHOW)"
                        @focusout="toggleAllProducts(index, HIDE, item.productid)"
                        @change="getActiveProuct(index, item.productid)"
                        item-text="productName" outlined dense
                        item-value="id" :placeholder="$t('message.common.typeHere')"
                        hide-details full-width>
                      </v-autocomplete>
                    </td>
                    <td>
                      <v-autocomplete :placeholder="$t('message.common.typeHere')" :items="listOfLocations" item-text="name" item-value="id" hide-details full-width
                        :rules="(item.productid && sheetObj.type !== 'quick') ? $_requiredValidation : []" v-model="item.locationid" @change="updateOnStockForLocation('addNewItems', index, item.productid, item.locationid, item.batchnumber)"
                        autocomplete="off" outlined dense :ref="'location_'+index"></v-autocomplete>
                    </td>
                    <td class="pa-0 pl-1">
                      <v-text-field :placeholder="$t('message.common.typeHere')" class="pa-0" v-model="item.batchnumber"
                        :rules="(item.locationid && sheetObj.type !== 'quick') ? $_requiredValidation : []" v-if="item.isbatch" @change="updateOnStockForLocation('addNewItems', index, item.productid, item.locationid, item.batchnumber)"
                        hide-details full-width outlined dense>
                      </v-text-field>
                    </td>
                    <td>{{ item.unit }}</td>
                    <td>{{ item.salesprice | replaceDotWithComma }}</td>
                    <td>{{ item.onstock | replaceDotWithComma }}</td>
                    <td class="pa-0">
                      <v-text-field :placeholder="$t('message.common.typeHere')" class="pa-0" v-model="item.counted" hide-details full-width :ref="'counted_'+index"
                      @keydown="$event.keyCode === 9 || $event.keyCode === 13 ? addRowWithFocus(index) : ''" @change="changesMade()"
                      :rules="item.counted ? $_norwegianNumberValidation : []" outlined dense>
                      </v-text-field>
                    </td>
                    <td v-if="!isSheetCompleted">
                      <v-btn class="mx-2" tabindex="-1" text fab dark small color="primary" @click="removeRow('addNewItems', index, 'new')">
                        <v-icon dark>mdi-minus-circle</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr v-for="(item, index) in items" :key="item.id">
                    <td>{{ `${item.productnumber || ''} - ${item.productname || ''}` }}</td>
                    <td>
                      <template v-if="sheetObj.type === 'quick' && !item.locationid_ref">
                        <v-autocomplete :placeholder="$t('message.common.typeHere')" :items="listOfLocations" item-text="name" item-value="id" hide-details full-width
                          v-model="item.locationid" @change="updateOnStockForLocation('listOfCCSheetItems', index, item.productid, item.locationid, item.batchnumber)"
                          autocomplete="off" outlined dense :ref="'location_main_'+index"></v-autocomplete>
                      </template>
                      <template v-else>
                        {{ item.locationname }}
                        <template v-if="!isSheetCompleted">
                          <v-icon size="20" class="ml-2" @click="changeLocationDialog(item.id, item.productid, item.onstock, item.locationid)" v-if="item.onstock ? +$formatter.replaceCommaWithDot(item.onstock) > 0 : false">mdi-pencil</v-icon>
                        </template>
                      </template>
                    </td>
                    <td>
                      <v-text-field v-if="sheetObj.type === 'quick' && item.producthasbatch && !item.batchnumber_ref" :placeholder="$t('message.common.typeHere')" class="pa-0" v-model="item.batchnumber"
                        :rules="(item.batchnumber && sheetObj.type !== 'quick') ? $_requiredValidation : []" @change="updateOnStockForLocation('listOfCCSheetItems', index, item.productid, item.locationid, item.batchnumber)"
                        hide-details full-width outlined dense>
                      </v-text-field>
                      <template v-else>
                        {{ item.batchnumber }}
                      </template>
                    </td>
                    <td>{{ item.productunit }}</td>
                    <td>{{ item.salesprice | replaceDotWithComma }}</td>
                    <td>{{ item.onstock }}</td>
                    <td class="pa-0" :style="{ background: item.color }">
                      <v-text-field class="pa-0" :placeholder="$t('message.common.typeHere')"
                        @change="saveCountedValue(item.id, item.counted)"
                        @input="onValueChanges(index)" :rules="$_norwegianNumberValidation"
                        :disabled="isSheetCompleted" outlined dense
                        v-model="item.counted" hide-details full-width></v-text-field>
                    </td>
                    <td v-if="!isSheetCompleted">
                      <v-btn tabindex="-1" class="mx-2" text fab dark small color="primary" @click="removeRow('listOfCCSheetItems', index, 'saved')">
                        <v-icon dark>mdi-minus-circle</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
          </v-data-table>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn color="success" dark id="saveCCSheetItems" v-if="isNewItemsAdded" @click="saveCCSheetItemsHandler">{{ $t('message.common.save') }}</v-btn>
          <v-btn color="success" class="ml-2" dark id="completeCCSheetItems" v-if="isAllCounted && !isSheetCompleted" @click="completeSheetItems">{{ $t('message.common.complete') }}</v-btn>
          <v-btn color="error" class="ml-2" dark id="backToList" to="/w_h/ccsheet">{{ $t('message.common.backToList') }}</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
    <!-- COMPLETE CCSHEET WARNING -->
    <v-dialog v-model="completeCCSheet.dialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.common.warning') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t('message.ccsheet.completeSheet') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="completeConfirm" :loading="completeCCSheet.loading" @click="completeCCSheet.onSuccess">{{ $t('message.common.yes') }}</v-btn>
          <v-btn color="primary" id="confirmClose" @click="completeCCSheet.onClose">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent max-width="600px" v-model="locationChangeDialog">
      <v-card>
        <v-card-title>
          <h3>{{$t('message.warehouse.moveProduct')}}</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2 pb-2">
          <v-autocomplete v-model="quickLocationObj.tolocationid" :items="stockLocations" autocomplete="off"  class="mt-1"
            @keyup="$event.keyCode !== 13 ? getWarehouseLocationsForStock('searchLocation', $event) : ''"
            ref="searchLocation" outlined dense
            @click="toggleLocations(SHOW)"
            @focusout="toggleLocations(HIDE, quickLocationObj.tolocationid)"
            item-text="name" item-value="id"
            hide-details :placeholder="$t('message.order.searchLocation')">
            <template v-slot:no-data>
              <span class="pa-1 caption">{{ $t('message.common.noResults') }}</span>
            </template>
          </v-autocomplete>
          <v-checkbox dense hide-details class="mt-3" v-model="quickLocationObj.setasdefaultlocation" :label="$t('message.warehouse.changeDefaultLoc')"></v-checkbox>
          <v-progress-linear v-if="loadingLocations" rounded indeterminate></v-progress-linear>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-flex class="text-center">
            <v-btn color="success" @click="changeTheLocationHandler">{{$t('message.common.change')}}</v-btn>
            <v-btn color="error" class="ml-2" @click="locationChangeDialog = false">{{$t('message.common.close')}}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex'
export default {
  data () {
    return {
      listOfCCSheetItems: [],
      listOfLocations: [],
      stockLocations: [],
      addNewItems: [],
      isAllCounted: false,
      isNewItemsAdded: false,
      sheetId: 0,
      sheetObj: {},
      filterByLocation: 0,
      filterByProductGroup: [],
      searchFilter: '',
      loading: false,
      searchInput: '',
      dialog: false,
      selectedLocation: '',
      enableScanner: false,
      removeIndex: '',
      loadingProducts: false,
      completeCCSheet: {
        dialog: false
      },
      paginationObj: {},
      total: 0,
      isAllHaveLocAndCounted: false,
      quickLocationObj: {
        warehouseid: 0,
        fromlocationid: 0,
        tolocationid: 0,
        productid: 0,
        qty: 0
      },
      locationChangeDialog: false,
      loadingLocations: false
    }
  },
  created () {
    this.sheetId = this.$route.params.sheet_id
  },
  computed: {
    ...mapState(['listOfProducts', 'listOfProductGroups']),
    headers () {
      let headers = [{
        text: this.$t('message.warehouse.product'),
        width: '25%',
        value: 'productnumber',
        required: true
      }, {
        text: this.$t('message.stock.location'),
        width: '20%',
        value: 'locationname',
        required: true
      }, {
        text: this.$t('message.order.batchNo'),
        width: '10%',
        value: 'batchnumber',
        required: true
      }, {
        text: this.$t('message.product.unit'),
        value: 'productunit',
        width: '10%'
      }, {
        text: this.$t('message.stock.costPrice'),
        value: 'salesprice',
        width: '10%'
      }, {
        text: this.$t('message.ccsheet.onStock'),
        value: 'onstock',
        width: '10%'
      }, {
        text: this.$t('message.ccsheet.counted'),
        value: 'counted',
        width: '15%'
      }]
      if (!this.isSheetCompleted) {
        headers.push({
          text: this.$t('message.tickets.actions'),
          value: 'actions',
          sortable: false,
          width: '4%'
        })
      }
      return headers
    },
    getStatusText () {
      let status = this.sheetObj.status
      let item = this.$_ccsheetStatus.find(x => x.value === status)
      return item ? item.text : ''
    },
    isSheetCompleted () {
      let status = this.sheetObj.status === this.COMPLETED || this.sheetObj.status === 'recount' || this.sheetObj.status === this.COUNTED || this.sheetObj.status === this.COMPLETED_AND_ADJUSTED || this.$route.params.has_edit
      let hasEdit = this.$route.params.has_edit
      if ((status && hasEdit) || (!status && !hasEdit)) return false
      else return true
    },
    selectedGroups () {
      const { productgroupids } = this.sheetObj
      let productGroups = this.listOfProductGroups
      if (productgroupids) {
        const ids = productgroupids ? JSON.parse(productgroupids) : []
        productGroups = productGroups.filter(x => ids.includes(x.id))
      }
      return productGroups
    }
  },
  mounted () {
    if (!this.$formatter.isEmptyObject(this.$store.state.F_WH_CCSHEET_ITEM_LIST)) {
      let data = this.$formatter.cloneVariable(this.$store.state.F_WH_CCSHEET_ITEM_LIST)
      let { searchFilter, filterByLocation, filterByProductGroup } = data.filter
      this.filterByLocation = filterByLocation || null
      this.filterByProductGroup = filterByProductGroup || null
      this.searchFilter = searchFilter || ''
    }
    this.getCCSheetObj()
    this.$store.dispatch('getProductGroups')
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === 'ccsheetitems') {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getCCSheetItems()
        this.removeIndex = ''
      }
    })
  },
  watch: {
    paginationObj (val) {
      this.getCCSheetItems()
    },
    searchFilter (val) {
      this.rememberFilterAndSearch()
      if (!val) this.getCCSheetItems()
    },
    filterByLocation (val) {
      this.rememberFilterAndSearch()
      this.getCCSheetItems()
    },
    filterByProductGroup () {
      this.rememberFilterAndSearch()
      this.getCCSheetItems()
    }
  },
  methods: {
    rememberFilterAndSearch () {
      let data = { type: 'F_WH_CCSHEET_ITEM_LIST', data: { filter: { searchFilter: this.searchFilter, filterByLocation: this.filterByLocation, filterByProductGroup: this.filterByProductGroup } } }
      this.$store.commit('rememberFilter', data)
    },
    // Searching products
    loadProducts (term, index, event) {
      if ([32, 37, 38, 39, 40].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      const pGroupIds = this.filterByProductGroup && this.filterByProductGroup.length > 0 ? this.filterByProductGroup : this.selectedGroups
      var filter = []
      pGroupIds.map((x, i) => {
        const id = x.id ? x.id : x
        if (i === 0) filter.push(`productgroupid eq '${id}'`)
        else filter.push(`OR productgroupid eq '${id}'`)
      })
      filter = filter.join(' ')
      if (searchText !== null) {
        let model = {
        'select': [],
        'expand': [{
          'select': ['id', 'name'],
          'model': 'ProductUnit',
          'on_field': 'id',
          'on_parent_field': 'unitid'
        }],
        'filter': `number contains '${searchText}' OR name contains '${searchText}'`,
        'additionalfilters': filter && filter.length ? [filter] : '',
        'skip': 0,
        'limit': 50,
        'order_by': {
          'field': 'number',
          'asc_or_desc': 'desc'
        }
      }
      this.$_executeApi('post', 'products/query', model).then((response) => {
        this.addNewItems[index].products = []
        if (response.data.length > 0) {
          response.data = response.data.filter(x => !x.notinventoryitem && !x.isdeleted)
          response.data.forEach(element => {
            element.productName = element.number ? `${element.number} - ${element.name}` : element.name
          })
          this.addNewItems[index].products = response.data.filter(x => x.isactive)
        }
      })
      }
    },
    addRowWithFocus (index) {
      // let canAdd = true
      // if (this.addNewItems.length > 0 && !this.addNewItems[0].productid) {
      //   canAdd = false
      // }
      // if (canAdd) {
      this.addNewItemHandler()
      // }
    },
    //Remove Rows
    removeRow (items, index, type) {
      if (type === 'new') {
        this[items].splice(index, 1)
        this.$store.commit('isChangesMade', false)
      } else {
        let payload = { ids: [this[items][index].id], url: `ccsheetitems/delete_multiple`, module: 'ccsheetitems' }
        this.$store.commit('showDeleteDialog', payload)
        this.removeIndex = index
      }
    },
    clearProductValues(index) {
      let items = this.addNewItems[index]
      items.productid = null
      items.products = []
      this.$set(this.addNewItems, index, items)
    },
    getCCSheetItems () {
      this.loading = true
      let paginationModel = this.$formatter.cloneVariable(this.paginationObj)
      let queryModel = {
        ccsheetid: this.sheetId,
        descending: paginationModel.sortDesc && paginationModel.sortDesc[0] ? true : false,
        page: paginationModel.page,
        rowsperpage: paginationModel.itemsPerPage,
        sortby: paginationModel.sortBy && paginationModel.sortBy[0] ? paginationModel.sortBy[0] : null,
        search: this.searchFilter || null,
        getonlymismatching: !!this.$route.params.has_edit,
        locationid: this.filterByLocation || 0,
        productgroupids: this.filterByProductGroup || []
      }
      this.$_executeApi('post', 'ccsheetitems/paginate_filter', queryModel)
        .then((response) => {
          let transformData = { number: { list: ['onstock', 'counted'], format: 'replaceDotWithComma' } }
          let resultedItems = response.data.items || []
          this.total = response.data.total
          resultedItems.forEach((item, index) => {
            // item.hideRow = false
            // if (this.$route.params.has_edit && (item.counted && item.onstock === item.counted)) {
            //   item.hideRow = true
            // }
            item.locationid_ref = item.locationid
            item.batchnumber_ref = item.batchnumber
            if (!item.onstock) item.onstock = 0
            let counted = this.$formatter.isNullOrEmpty(item.counted)
            if (!counted && item.onstock === item.counted) item.color = '#4caf506b'
            else if (!counted && item.onstock !== item.counted) item.color = '#fe7171ab'
            else if (counted) item.color = '#80808057'
          })
          this.checkIfAllProductsCounted()
          // let items = resultedItems.filter(x => !x.hideRow)
          this.listOfCCSheetItems = this.$_formatListModel(resultedItems, transformData)
          // if (this.$route.params.has_edit) this.total = items.length
          this.loading = false
          if (resultedItems.length === 0) {
            this.addRowWithFocus()
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getCCSheetObj (loadItems = false) {
      this.loading = true
      let hasEdit = this.$route.params.has_edit
      this.$_executeApi('get', `ccsheets/get_ccsheet/${this.sheetId}?get_for_counting=${hasEdit ? hasEdit : false}`)
        .then((response) => {
          this.sheetObj = response.data
          if (loadItems) this.getCCSheetItems()
          this.getWarehouseLocations()
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    getWarehouseLocations () {
      let model = {
        'filter': `isactive eq 1 AND warehouseid eq ${this.sheetObj.warehouseid}`,
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        }
      }
      this.$_executeApi('post', 'warehouselocations/query', model)
        .then((response) => {
          this.listOfLocations = response.data
        })
    },
    getWarehouseLocationsForStock (term, event) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term].lazySearch
      if (searchText !== null) {
        let query = {
          select: ['id', 'name', 'warehouseid', 'isdefault'],
          additionalfilters: [`name contains  '${searchText}'`],
          skip: 0,
          limit: 50,
          filter: `isactive eq 1 and warehouseid eq ${this.quickLocationObj.warehouseid || 0}`,
          'order_by': {
            'field': 'name',
            'asc_or_desc': 'asc'
          }
        }
        this.$_executeApi('post', 'warehouselocations/query', query).then((response) => {
          this.stockLocations = response.data
        })
      }
    },
    changeTheLocationHandler () {
      this.quickLocationObj.fromccsheet = true
      this.$_executeApi('post', 'warehouseorderitems/quick_change_location', this.quickLocationObj)
        .then((response) => {
          if (response && response.data) {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.actionPerformed') })
            this.locationChangeDialog = false
            this.getCCSheetItems()
          }
        })
    },
    async toggleLocations (action, locationid = 0) {
      if (locationid) {
        if (action === this.HIDE && this.stockLocations) {
          let locations = this.stockLocations.filter(x => x.id === locationid)
          this.stockLocations = locations
        }
      }
    },
    addNewItemHandler () {
      let canAdd = true
      if (this.addNewItems.length > 0 && !this.addNewItems[0].productid) {
        canAdd = false
      }
      if (canAdd) {
        let arrayIndex = this.addNewItems.length === 0 ? 1 : this.addNewItems.length + 1
        if (this.selectedLocation) {
          this.addNewItems.push({ productid: 0, locationid: this.selectedLocation, onstock: 0, counted: null, products: [], index: arrayIndex })
        } else {
          this.addNewItems.push({ productid: 0, locationid: 0, onstock: 0, counted: null, products: [], index: arrayIndex })
        }
        this.isAllCounted = false
        this.isNewItemsAdded = true
        setTimeout(() => {
          let index = 0
          let focus = 'searchInput'+(index)
          if (this.$refs[focus] && this.$refs[focus][0]) {
              this.$nextTick(() => {
                this.$refs[focus][0].focus()
              })
          }
        }, 200)
      } else if (this.selectedLocation) {
        this.addNewItems[0].locationid = this.selectedLocation
      }
      this.addNewItems = this.addNewItems.sort((v1, v2) => v2.index - v1.index).map((v) => v)
    },
    async getActiveProuct (index, productid) {
      this.changesMade()
      let getProduct = this.addNewItems[index].products
      if (getProduct) {
        let getObj = this.$formatter.cloneVariable(this.addNewItems[index])
        let result = getProduct.find(x => x.id === productid)
        // if (result && result.ispackage) {
        //   this.loadingProducts = true
        //   this.getProductsByPackage(productid, index)
        // }
        getObj.isbatch = result.batchrequired
        // getObj.onstock = this.$formatter.replaceDotWithComma(result.minstock)
        getObj.unit = result.productunit_name || ''
        getObj.salesprice = result.costprice
        const { locationid, onstock } = await this.getLocationsHandler(productid)
        if(locationid != 0) {
          getObj.locationid = locationid
          getObj.onstock = onstock
        }
        this.$set(this.addNewItems, index, getObj)
        setTimeout(() => {
          let focus = 'location_'+(index)
          this.$nextTick(() => {
            this.$refs[focus][0].focus()
          })
        }, 100)
      }
    },
    focusOnQty (index) {
      let focus = 'counted_'+(index)
      this.$nextTick(() => {
        this.$refs[focus][0].focus()
      })
      this.changesMade()
    },
    async getProductsByPackage (id, index) {
      let query = {
        select: [],
        expand: [{
          'model': 'Product',
          'on_field': 'id',
          'on_parent_field': 'productid'
        }],
        filter: `packageid eq '${id}'`
      }
      this.$_executeApi('post', 'productpackages/query', query)
        .then(async (response) => {
          let getAllProducts = []
          let list = response.data
          for (let i = 0; i < list.length; i++) {
            let products = [{ id: list[i].product_id, productName: list[i].product_number ? `${list[i].product_number} - ${list[i].product_name}` : list[i].product_name }]
            getAllProducts.push({ products,
              productid: list[i].product_id,
              isbatch: list[i].product_batchrequired,
              productName: list[i].product_number ? `${list[i].product_number} - ${list[i].product_name}` : list[i].product_name })
          }
          let getExistingItems = this.$formatter.cloneVariable(this.addNewItems)
          getExistingItems.splice(index, 1)
          getExistingItems.push(...getAllProducts)
          this.addNewItems = getExistingItems
        })
        .finally(() => {
          this.loadingProducts = false
        })
    },
    saveCCSheetItemsHandler (isListLoad = true) {
      return new Promise((resolve, reject) => {
        if (this.$refs.ccsheetItems.validate()) {
          let model = { sheetid: this.sheetId, stocks: [] }
          let transformData = { number: { list: ['counted', 'onstock'], format: 'replaceCommaWithDot' } }
          const list = [...this.addNewItems, ...this.listOfCCSheetItems]
          model.stocks = this.$_formatListModel(list, transformData)
          if (model.stocks) {
            model.stocks.map(x => {
              if (!x.onstock) x.onstock = 0
              return x
            })
          }
          this.$_executeApi('post', `ccsheets/save_ccsheet`, model)
            .then((response) => {
              this.$store.commit('isChangesMade', false)
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.actionPerformed') })
              if (isListLoad) this.getCCSheetObj(true)
              this.addNewItems = []
              this.isNewItemsAdded = false
              resolve()
            })
        } else {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
          resolve()
        }
      })
    },
    changeLocationDialog (itemId, productId, onStock, locationid) {
      this.locationChangeDialog = true
      this.quickLocationObj.setasdefaultlocation = true
      this.quickLocationObj.fromlocationid = locationid
      this.quickLocationObj.tolocationid = 0
      this.quickLocationObj.warehouseid = this.sheetObj.warehouseid
      this.quickLocationObj.productid = productId
      this.quickLocationObj.ccsheetitemid = itemId
      this.quickLocationObj.qty = this.$formatter.replaceCommaWithDot(onStock)
      this.getLocationsHandler(productId, true)
        .then((data) => {
          this.stockLocations = data
        })
    },
    getLocationsHandler (productid, fromStock = false) {
      if (this.sheetObj.warehouseid && productid) {
        if (fromStock) this.loadingLocations = true
        return new Promise((resolve, reject) => {
          this.$_executeApi('get', `/stocks/get_product_by_warehouse?product_id=${productid}&warehouse_id=${this.sheetObj.warehouseid}`)
            .then((result) => {
              let model = result.data
              model = model.filter(x => x.on_stock > 0)
              if (fromStock) {
                model.map(x => {
                  x.id = x.locationid
                  x.name = x.location_name
                  return x
                })
                this.loadingLocations = false
                resolve(model)
              } else {
                if (model && model.length === 1) {
                  resolve({ locationid: model[0].locationid, onstock: model[0].on_stock })
                } else {
                  resolve(0)
                }
              }
            })
            .catch((err) => {
              reject(err)
            })
        })
      } else return Promise.resolve()
    },
    async updateOnStockForLocation (type, index, productid, location_id, batch) {
      const { locationid, onstock } = await this.getStockValueFromLocationHandler(productid, location_id, batch)
      if (locationid && locationid != 0) {
          const getObj = this[type][index]
          getObj.locationid = locationid
          getObj.onstock = onstock
          this.$set(this[type], index, getObj)
      } else {
        const getObj = this[type][index]
        getObj.onstock = 0
        this.$set(this[type], index, getObj)
      }
      if (type === 'listOfCCSheetItems') {
        this.isNewItemsAdded = true
      } else {
        this.focusOnQty(index)
      }
    },
    getStockValueFromLocationHandler (productid, locationid, batch) {
      if (this.sheetObj.warehouseid && productid && locationid) {
        return new Promise((resolve, reject) => {
          this.$_executeApi('get', `/stocks/get_product_by_warehouse_and_location?product_id=${productid}&warehouse_id=${this.sheetObj.warehouseid}&locationid=${locationid}`)
            .then((result) => {
              let model = result.data
              model = model.filter(x => x.on_stock > 0)
              if (batch) {
                model = model.filter(x => x.batchnumber === batch)
                if (model && model.length === 1) {
                  resolve({ locationid: model[0].locationid, onstock: model[0].on_stock })
                } else {
                  resolve(0)
                }
              } else {
                if (model && model.length === 1) {
                  resolve({ locationid: model[0].locationid, onstock: model[0].on_stock })
                } else {
                  resolve(0)
                }
              }
            })
            .catch((err) => {
              reject(err)
            })
        })
      } else return Promise.resolve()
    },
    completeSheetItems () {
      if (this.$refs.ccsheetItems.validate()) {
        this.completeCCSheet = {
          dialog: true,
          loading: false,
          onSuccess: () => {
            if (this.$store.state.isChangesMade) {
              this.saveCCSheetItemsHandler(false)
                .then(() => {
                  this.completeCCSheetHandler()
                })
            } else {
              this.completeCCSheetHandler()
            }
          },
          onClose: () => {
            this.completeCCSheet.dialog = false
            this.completeCCSheet.loading = false
          }
        }
      }
    },
    completeCCSheetHandler () {
      this.completeCCSheet.loading = true
      let model = { sheetid: this.sheetId, stocks: [] }
      let transformData = { number: { list: ['onstock', 'counted'], format: 'replaceCommaWithDot' } }
      model.stocks = this.$_formatListModel(this.listOfCCSheetItems, transformData)
      this.$_executeApi('post', `ccsheets/complete_ccsheet`, model)
        .then((response) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.actionPerformed') })
          this.completeCCSheet.dialog = false
          this.completeCCSheet.loading = false
          this.$router.push('/w_h/ccsheet')
        })
    },
    checkForSameProducts() {
      let savedItems = this.$formatter.cloneVariable(this.listOfCCSheetItems)
      let newItems = this.$formatter.cloneVariable(this.addNewItems)
      var existsInSaved = false
      if (savedItems.length > 0) {
        savedItems.forEach(element => {
          let result = newItems.find(x => x.productid === element.productid)
          if (result) existsInSaved = true
          return false
        })
      }
      if (newItems.length > 1) {
      // To check whether same products is selected
        for (var i = 0; i < newItems.length; i++) {
          for (var j = 0; j < newItems.length; j++) {
            // eslint-disable-next-line
            if (i != j) {
              if (newItems[i].productid === newItems[j].productid) {
                existsInSaved = true
              }
            }
          }
        }
      }
      return existsInSaved
    },
    checkCurrentExisting (id, index) {
      let savedItems = this.$formatter.cloneVariable(this.listOfCCSheetItems)
      let newItems = this.$formatter.cloneVariable(this.addNewItems)
      var existsInSaved = false
      if (savedItems.length > 0) {
        savedItems.forEach(element => {
          if (element.productid === id) {
            existsInSaved = true
          }
        })
      }
      if (newItems.length > 1) {
        for (var i = 0; i < newItems.length; i++) {
          if (i !== index && newItems[i].productid === id) {
            existsInSaved = true
          }
        }
      }
      return existsInSaved
    },
    // Save counted value from CCSheet item
    saveCountedValue (itemId, value) {
      if (this.$refs.ccsheetItems.validate()) {
        let counted = value ? this.$formatter.replaceCommaWithDot(value) : ''
        this.$_executeApi('post', `/ccsheets/save_counted/${itemId}?count=${counted}`).then(response => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updateMsg') })
          this.isAllCounted = response.data.allcounted
        })
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.invalidDataFound') })
      }
    },
    // Check if all the items has counted value, NOTE: 0 is also a value
    onValueChanges (index) {
      let ccsheetItems = this.$formatter.cloneVariable(this.listOfCCSheetItems)
      let sheetItem = ccsheetItems[index]
      let { onstock, counted } = sheetItem
      let color = ''
      onstock = onstock.toString()
      if (counted && onstock === counted) color = '#4caf506b'
      else if (counted && onstock !== counted) color = '#fe7171ab'
      else if (counted === '') color = '#80808057'
      let updateItem = Object.assign({ ...sheetItem }, { color })
      this.$set(this.listOfCCSheetItems, index, updateItem)
    },
    updateComments () {
      this.$_executeApi('put', `/ccsheets/${this.sheetObj.id}`, { comments: this.sheetObj.comments })
    },
    checkIfAllProductsCounted () {
      let query = {
        'skip': 0,
        'limit': -1,
        'filter': `ccsheetid eq ${this.sheetId}`
      }
      this.$_executeApi('post', '/ccsheetitems/query', query)
      .then(response => {
        const ccsheetItems = response.data
        if (this.$formatter.isArrayHasData(response.data)) {
          let totalCount = ccsheetItems.filter(x => !x.locationid || (x.counted != 0 && !x.counted)).length
          if (totalCount === 0) this.isAllCounted = true
          else this.isAllCounted = false
        }
      })
    },
    // Show and Hide products in the array for performence when having more items
    toggleAllProducts (index, action, productId) {
      let items = this.$formatter.cloneVariable(this.addNewItems)
      if (action === this.HIDE) {
        let products = items[index].products.filter(x => x.id === productId)
        items[index].products = products
      }
      if (this.checkCurrentExisting(productId, index)) {
        items[index].color = '#f5696999'
      } else {
        items[index].color = undefined
      }
      this.$set(this.addNewItems, index, items[index])
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  }
}
</script>
<style>
.dense_table.v-data-table tbody tr:hover:not(.v-data-table__expanded__content) {
  background: rgba(128, 128, 128, 0.05) !important ;
}
</style>
